export default class ResolutionContext {
    constructor() {
        this.scopedResolutions = new Map();
    }
}
